import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";

export default function Marketplace() {
  const [courses, setCourses] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/courses/marketplace").then(r => setCourses(r.data)).catch(() => setCourses([]));
  }, []);

  const cats = ["All", ...new Set(courses.map(c => c.category).filter(Boolean))];
  const visible = courses.filter(c =>
    (cat === "All" || c.category === cat) &&
    (q === "" || c.title.toLowerCase().includes(q.toLowerCase()) || c.description.toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <Layout>
      <div className="px-10 py-10">
        <div className="mb-10">
          <div className="overline mb-3">Marketplace</div>
          <h1 className="editorial-h1 text-5xl mb-2">Training, sold direct.</h1>
          <p className="text-[#52525B] max-w-xl">Courses from the world's best practitioners. Buy seats for your team or enroll yourself.</p>
        </div>

        <div className="flex items-center gap-4 mb-8 flex-wrap">
          <div className="flex items-center gap-2 bg-white border border-[#E4E4E7] px-4 py-2 flex-1 min-w-[260px] max-w-md">
            <Search size={16} strokeWidth={1.5} />
            <input data-testid="marketplace-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search courses…" className="flex-1 bg-transparent outline-none text-sm" />
          </div>
          <div className="flex gap-2 flex-wrap">
            {cats.map(c => (
              <button
                key={c}
                onClick={() => setCat(c)}
                data-testid={`category-filter-${c}`}
                className={`px-4 py-2 border text-sm font-display transition-colors ${cat === c ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "bg-white border-[#E4E4E7] hover:border-[#0A0A0A]"}`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        {visible.length === 0 ? (
          <div className="editorial-card-static p-16 text-center">
            <div className="font-serif text-3xl mb-2">No courses match.</div>
            <div className="text-[#52525B]">Try a different search or category.</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {visible.map(c => (
              <Link key={c.course_id} to={`/courses/${c.course_id}`} data-testid={`marketplace-card-${c.course_id}`} className="editorial-card block">
                <img src={c.thumbnail} className="w-full h-52 object-cover" alt="" />
                <div className="p-6">
                  <div className="overline mb-2">{c.category}</div>
                  <div className="font-serif text-2xl leading-tight mb-3">{c.title}</div>
                  <div className="text-sm text-[#52525B] line-clamp-3 mb-5">{c.description}</div>
                  <div className="flex items-center justify-between pt-4 border-t border-[#E4E4E7]">
                    <div className="overline">By {c.created_by_name || "Forge"}</div>
                    <div className="font-display font-semibold text-lg text-[#E63946]">{c.price > 0 ? `$${c.price}` : "Free"}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
